import Link from "next/link";
import '@/styles/components/ui/cta.css';

const CTA = ({layout = "", type = "link", text = "Button", url = "/"}) => (
  <div className={`cta ${layout}`}>
    {type === "link" ? (
      <Link href={url} className="cta__button">{text}</Link>
    ) : (
      <button className="cta__button">{text}</button>
    )}
  </div>
);

export default CTA;
